<template>
  <div class="user-profile">
    <h5>User Profile</h5>
    <div class="row" v-for="name in profile.attrNames">
      <div>{{ name }}</div>
      <div class="access"><small>{{ profile.access[name] }}</small></div>
      <div class="value">{{ output(name) }}</div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
  .user-profile {
    padding: 20px;
    background: #eef1f6;

    h5 {
      margin: 0;
      border-bottom: 1px solid #fff;
      padding-bottom: 3px;
    }

    .row {
      display: flex;

      & > div {
        flex: 1 0 0;
        padding: 2px 0;
        &.access {
          flex: 0 0 70px;
        }
        &.value {
          flex-grow: 3;
        }
      }
    }
  }
</style>
<script>
import moment from 'moment'

export default {
  props: ['profile'],
  methods: {
    output (attrName) {
      const value = this.profile.entities[attrName]
      if (value) {
        switch (attrName) {
          case 'licence':
          case 'birth':
            return moment(value).format('ll')
          case 'gender':
            return value === 'm' ? 'male' : 'female'
          case 'location':
            return `lat: ${value[0]}, lng: ${value[1]}`
          default:
            return value
        }
      }
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/users/UserProfile.vue